import { useEffect } from "react";
import { useListChatConversationsQuery } from "../../api/chatApi";
import type { ChatConversationDto } from "../../contracts";
import { realtimeEvents } from "../../features/signalr/realtimeEvents";
import { useSignalR } from "../../features/signalr/useSignalR";

export const commercialHistoryQueryArgs = {
    skip: 0,
    take: 50
};

interface UseCommercialHistoryConversationsResult {
    conversations: ChatConversationDto[];
    isLoading: boolean;
    isError: boolean;
    refetch: () => void;
}

export const useCommercialHistoryConversations = (): UseCommercialHistoryConversationsResult => {
    const { data, isLoading, isError, refetch } = useListChatConversationsQuery(commercialHistoryQueryArgs);
    const { connection } = useSignalR();

    useEffect(() => {
        if (!connection) {
            return;
        }

        const handleConversationCreated = (conversation: ChatConversationDto) => {
            void conversation;
            void refetch();
        };
        const handleChatJobUpdated = () => {
            void refetch();
        };

        connection.on(realtimeEvents.conversationCreated, handleConversationCreated);
        connection.on(realtimeEvents.chatJobUpdated, handleChatJobUpdated);

        return () => {
            connection.off(realtimeEvents.conversationCreated, handleConversationCreated);
            connection.off(realtimeEvents.chatJobUpdated, handleChatJobUpdated);
        };
    }, [connection, refetch]);

    return {
        conversations: data?.data ?? [],
        isLoading,
        isError,
        refetch
    };
};
